import { EVENT_SEARCH_MODAL_CLOSING } from "../constants";

export default function propagateSearchModalClose() {
  // Check if we are in the client
  if (typeof window !== "object" || typeof CustomEvent !== "function") {
    console.warn(
      "[Search-ui] Calling search modal close on a server function, ignoring request...",
    );
    return;
  }

  const event = new CustomEvent(EVENT_SEARCH_MODAL_CLOSING, {
    detail: {
      timestamp: Date.now(),
    },
  });

  window.dispatchEvent(event);
}
